import React from "react";
import { router } from "./router";
import { RouterProvider } from "react-router-dom";

/**
 * Main App component.
 * Renders the React Router 7 provider with our route configuration.
 * All providers (Auth, Toast, A11y) are now in RootLayout.
 */
export default function App(): JSX.Element {
  return <RouterProvider router={router} />;
}
